import type { SVGProps } from 'react';
const SvgImagesearchRoller = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#imagesearch_roller_svg__a)">
      <path
        fill="currentColor"
        d="M20 2v6H6V6H4v4h10v5h2v8h-6v-8h2v-3H2V4h4V2"
      />
    </g>
    <defs>
      <clipPath id="imagesearch_roller_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgImagesearchRoller;
